import {connect} from 'react-redux';
import {QuestionCSCQ as Component} from './QuestionCSCQ';
import {
  selectQuestionOption,
  selectCheckboxOption,
  responseOEQChange,
  responseNEQChange,
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    interactionProps: {
      solutions: (state.notebook.protocolSection.scene.hasOwnProperty("apparatus"))?state.notebook.protocolSection.scene.apparatus.solutions:null,
      agaroseGel: (state.notebook.protocolSection.scene.hasOwnProperty("apparatus"))?state.notebook.protocolSection.scene.apparatus.agaroseGel:null
    }
  };
}

function mapDispatchToProps(dispatch) {
  return {
    selectOption: (option) => dispatch(selectQuestionOption(option)),
    selectCheckbox: (option) => dispatch(selectCheckboxOption(option)),
    responseOEQChange: (response) => dispatch(responseOEQChange(response)),
    responseNEQChange: (response) => dispatch(responseNEQChange(response))
  };
}

export const QuestionCSCQ = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
